import type {AEntity} from './abstract/AEntity'

export interface IContactEquipe {
    conLib: string;
    conChamp: string
}

export class ContactEquipe implements AEntity {
    conLib: string;
    conChamp: string;

    constructor(contact: IContactEquipe) {
        this.conLib = contact.conLib;
        this.conChamp = contact.conChamp;
    }

    getId(): string {
        return this.conLib;
    }

    toJSON(): IContactEquipe {
        return {
            conLib: this.conLib,
            conChamp: this.conChamp
        }
    }
}
